import type { IFlattenedCategory } from "app/common/services/categoryService.types";
import { allTrackers } from "app/services/track/track";

export const onCategoryCellClick = (category: IFlattenedCategory) => {
    const { text: categoryText, parentItem } = category;
    const isChildCategory = Boolean(parentItem);
    const categoryDetails = isChildCategory ? `${parentItem.text}/${categoryText}` : `${categoryText}`;
    allTrackers.trackEvent("Internal link", "click", `Cross industry overview/${categoryDetails}`);
};
